'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

exports.default = function () {
  var productLabel = new ProductLabel();
  productLabel.init();
};

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ProductLabel = function () {
  function ProductLabel() {
    (0, _classCallCheck3.default)(this, ProductLabel);
  }

  (0, _createClass3.default)(ProductLabel, [{
    key: 'showLabel',
    value: function showLabel(elm) {
      var $this = (0, _jquery2.default)(elm);
      var thisText = $this.data('label') || '';

      // saving origin letter

      if (!$this.data('in-progress')) {
        $this.data('in-progress', true);

        // for good padding after show all letters
        var adictionalWith = $this.closest('.product__labels').length ? 20 : 13;

        if ($this.data('first-width') === undefined) {
          var firstWidth = $this.outerWidth();
          $this.data('first-width', firstWidth);
        }

        $this.html('<span>' + thisText + '</span>');
        var newWidth = (0, _jquery2.default)('span', $this).outerWidth() + adictionalWith;

        $this.css({
          width: newWidth
        });

        var letters = thisText.split('');
        $this.html('<span class="show">' + letters[0] + '</span>');
        var speed = 800 / letters.length;

        setTimeout(function () {
          for (var i = 0; i < letters.length - 1; i++) {
            (function (index) {
              setTimeout(function () {
                $this.append('<span>' + letters[index + 1] + '</span>');
                $this.find('span:last-child').addClass('show');
              }, speed * index * Math.pow(0.4, 2));
            })(i);
          }
        }, 400);

        // close
        var timeClose = 2000;
        setTimeout(function () {
          for (var i = 0; i < letters.length - 1; i++) {
            (function (index) {
              setTimeout(function () {
                $this.find('span:last-child').remove();
              }, speed * index * Math.pow(0.7, 2));
            })(i);
          }

          setTimeout(function () {
            if ($this.data('label-origin') != $this.find('span:first-child').text()) {
              $this.html($this.data('label-origin'));
            }
            $this.data('in-progress', false);
          }, 600);
        }, timeClose);

        setTimeout(function () {
          $this.css({ width: $this.data('first-width') }); // ala css width dont ask why it's not variable
        }, timeClose - 200);
      }
    }
  }, {
    key: 'init',
    value: function init() {
      var self = this;
      var $label = (0, _jquery2.default)('.p-label:not(.p-label--lang)');
      if ($label.length === 0) return;

      $label.each(function () {
        (0, _jquery2.default)(this).data('in-progress', false).data('label-origin', (0, _jquery2.default)(this).text());
      });

      (0, _jquery2.default)(document).on('mouseover', 'figure', function () {
        var labels = (0, _jquery2.default)(this).find('.p-label:not(.p-label--lang)');
        labels.each(function () {
          self.showLabel(this);
        });
      });

      // TOTO: mozna vymyslet nejaky jiny close, to reknou oni

      // $(document).on('click', function(){

      // });
    }
  }]);
  return ProductLabel;
}();

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/initializers/ProductLabel.js
// module id = 1049
// module chunks = 0